import { observer } from 'mobx-react-lite';
import { useStore } from '../../../../../hooks/useStore';
import { PayrollExportMappingTable } from './table';
import { useCompanySettings } from '../../../../../queries/company';

export const PayrollMappingView = observer(() => {
  const { companyStore } = useStore();

  const { data: companySettings } = useCompanySettings(companyStore.company?.id ?? '');

  return (
    <PayrollExportMappingTable
      company={companyStore.company?.id ?? 'MISSING_ID'}
      system={companySettings?.payroll_system}
    />
  );
});
